import { Row } from "@tanstack/react-table";
import { Media } from "components";
import { memo } from "react";

import { ProductSetsListItem } from "../../productsSets.types";

import styles from "./ProductSetsTable.module.scss";

export const CoverMediaCell = memo(
  ({ row }: { row: Row<ProductSetsListItem> }) => (
    <Media
      mediaFile={row.original.coverMedia}
      controls={false}
      withVideoLabel
      className={styles.productSetsTable_coverMedia}
    />
  )
);

CoverMediaCell.displayName = "CoverMediaCell";
